// extracted by mini-css-extract-plugin
module.exports = {"image":"About_image__sOw_H"};